import React, { ReactNode, useContext, useState } from 'react';
import { Avatar, Box, Fade, IconButton, Menu, MenuItem, MenuProps, Typography } from '@material-ui/core';

import { AccountCircle } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { UserContext, UserProfile } from '../../react-commons/context/userContext';

export const UserHeadline: React.FC<{ user: UserProfile }> = ({ user }) => {
  const name = `${user.firstName} ${user.lastName}`;
  return (
    <>
      <Box display="flex" flexDirection="column" justifyContent="center">
        <Fade in={!!user.email}>
          <Typography align="right" variant="subtitle2">
            {user.email}
          </Typography>
        </Fade>
        {name && (
          <Fade in={!!name}>
            <Typography align="right" variant="caption" data-id="user-full-name">
              {name}
            </Typography>
          </Fade>
        )}
      </Box>
    </>
  );
};

export type MenuItemType = {
  key: string;
  onClick?: () => void;
  node: ReactNode;
};

export const UserMenu = () => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const user = useContext(UserContext);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const menuItems = [
    {
      key: 'passwordReset',
      node: 'Passwort zurücksetzen',
      onClick: () => {
        window.location.assign('/login/forgot-password');
      },
    },
    {
      key: 'logout',
      node: 'Ausloggen',
      onClick: () => {
        window.location.assign('/auth-signout');
      },
    },
  ];

  if (!user) return null;

  return (
    <Box display="flex" marginLeft={4}>
      <UserHeadline user={user} />
      <Box position="relative">
        <IconButton
          role="button"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleClick}
          color="primary"
        >
          {user ? <Avatar /> : <AccountCircle role="img" />}
        </IconButton>
        <Menu
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={closeMenu}
        >
          {menuItems.map((item: MenuItemType) => (
            <MenuItem key={item.key} onClick={item.onClick}>
              {item.node}
            </MenuItem>
          ))}
        </Menu>
      </Box>
    </Box>
  );
};
